import { queryOptions } from '@tanstack/react-query';
import { orderAPIClient } from '../orderAPIClient';
import { ORDER_QUERY_KEYS } from './keys';
import type { GetOrderRequest, GetOrdersRequest } from './types';

export const ORDER_QUERIES = {
  getOrder: (params: GetOrderRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrder(params),
      queryFn: () => orderAPIClient.getOrder(params),
      enabled: !!params.orderId,
      retry: false,
    });
  },

  getOrders: (params?: GetOrdersRequest) => {
    return queryOptions({
      queryKey: ORDER_QUERY_KEYS.getOrders(params),
      queryFn: () => orderAPIClient.getOrders(params),
    });
  },
};

